<template>
	<div>
		<GrossProfit v-if="view_code === 'GPT'" />
		<AccountReceived v-if="view_code === 'ARD'" />
		<SellerRank v-if="view_code === 'SGR'" />
		<BestItemList v-if="view_code === 'BSL'" :list_size="rowspan_cnt * 10" />
		<ItemClassGroup v-if="view_code === 'ICG'" />
		<CurrentStock v-if="view_code === 'CST'" />
		<ArTurnover v-if="view_code === 'ART'" />
	</div>
</template>

<script>
import BestItemList from '@/views/statistics/bestItem/BestItemList';
import GrossProfit from '@/views/statistics/grossProfit/GrossProfit';
import AccountReceived from '@/views/statistics/accountReceived/AccountReceived';
import SellerRank from '@/views/statistics/sellerRank/SellerRank.vue';
import ItemClassGroup from '@/views/statistics/itemClassGroup/ItemClassGroup.vue';
import CurrentStock from '@/views/statistics/currentStock/CurrentStock.vue';
import ArTurnover from '@/views/statistics/arTurnover/ArTurnover.vue';
export default {
	props: {
		view_code: String,
		rowspan_cnt: Number,
		colspan_cnt: Number,
	},
	components: {
		GrossProfit,
		AccountReceived,
		BestItemList,
		SellerRank,
		ItemClassGroup,
		CurrentStock,
		ArTurnover,
	},
};
</script>

<style></style>
